<template>
	<div class="task-menu pa-6">
		<v-card-title class="pa-0">Menu</v-card-title>

		<v-list nav>
			<v-list-group append-icon="mdi-menu-down">
				<template v-slot:activator>
					<v-list-item-title
						class="d-flex align-center font-weight-bold px-2"
					>
						<div class="d-flex align-center pr-2">
							<v-icon color="grey darken-3"> $todo-icon </v-icon>
						</div>
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.taskMenu.toDo"
							)
						}}
					</v-list-item-title>
					<div
						:key="allTasksCount[0]"
						class="number-of-tasks font-weight-bold text-subtitle-2 px-2 py-1"
					>
						{{ allTasksCount[0] }}
					</div>
				</template>

				<task-menu-item
					:isActive="activeList === list"
					@setAciveList="setActiveList(list)"
					:key="list.id"
					:listName="list.listName"
					:numberOfTasks="allTasksCount[i]"
					v-for="(list, i) in toDos"
				/>
			</v-list-group>

			<v-list-group append-icon="mdi-menu-down">
				<template v-slot:activator>
					<v-list-item-title
						class="d-flex align-center font-weight-bold px-2"
					>
						<div class="d-flex align-center pr-2">
							<v-icon color="grey darken-3">$task-list</v-icon>
						</div>
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.taskMenu.lists"
							)
						}}
					</v-list-item-title>
					<!-- <div
						class="number-of-tasks font-weight-bold text-subtitle-2 px-2 py-1"
					>
						12
					</div> -->
				</template>

				<task-menu-item
					:isActive="
						activeList.name === 'list' && activeList.id === list.id
					"
					@setAciveList="setActiveList({ name: 'list', id: list.id })"
					:id="list.id"
					:key="list.id"
					:listName="list.name"
					:numberOfTasks="list.total_tasks"
					type="list"
					v-for="list in lists"
				/>

				<v-list-item class="pa-0">
					<v-list-item-title class="d-flex justify-center px-2">
						<v-btn
							v-if="!addListInputVisible"
							height="32"
							elevation="0"
							color="secondary"
							@click.stop="activeAddListForm()"
						>
							+
							{{
								$vuetify.lang.t(
									"$vuetify.views.tasks.taskMenu.createNewList"
								)
							}}
						</v-btn>
						<div
							v-else
							v-click-outside="deactiveAddListForm"
							class="d-flex mt-3 width-100"
						>
							<v-text-field
								@keydown.enter="addNewList()"
								v-model="listName"
								:placeholder="
									$vuetify.lang.t(
										'$vuetify.views.tasks.taskMenu.addList'
									)
								"
								class="input-text caption font-weight-medium"
								dense
								hide-details
								outlined
							>
							</v-text-field>

							<v-btn
								@click="addNewList()"
								class="ml-3"
								color="secondary"
								elevation="0"
								height="32"
							>
								{{
									$vuetify.lang.t(
										"$vuetify.views.tasks.taskMenu.add"
									)
								}}
							</v-btn>
						</div>
					</v-list-item-title>
				</v-list-item>
			</v-list-group>

			<v-list-group append-icon="mdi-menu-down">
				<template v-slot:activator>
					<v-list-item-title
						class="d-flex align-center font-weight-bold px-2"
					>
						<div class="d-flex align-center pr-2">
							<v-icon color="grey darken-3">$tag</v-icon>
						</div>
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.taskMenu.tags"
							)
						}}
					</v-list-item-title>
				</template>

				<span :style="{ display: 'none' }" v-if="!tags.length"></span>

				<menu-tag-list
					:activeList="activeList"
					@setActiveList="setActiveList($event)"
				/>
			</v-list-group>

			<v-list-group append-icon="">
				<template v-slot:activator>
					<task-menu-item
						:isActive="activeList === list"
						@setAciveList="setActiveList(list)"
						:bold="true"
						:key="list.id"
						:link="false"
						:listName="list.listName"
						:numberOfTasks="recievedTasks"
						class="pa-0"
						icon="$received-task"
						v-for="list in received"
					/>
				</template>
			</v-list-group>

			<v-list-group append-icon="">
				<template v-slot:activator>
					<task-menu-item
						:isActive="activeList === list"
						@setAciveList="setActiveList(list)"
						:bold="true"
						:key="list.id"
						:link="false"
						:listName="list.listName"
						:numberOfTasks="commisionedTasks"
						class="pa-0"
						icon="$commissioned-task"
						v-for="list in commissioned"
					/>
				</template>
			</v-list-group>

			<v-list-group append-icon="">
				<template v-slot:activator>
					<task-menu-item
						:isActive="activeList === list"
						@setAciveList="setActiveList(list)"
						:bold="true"
						:key="list.id"
						:link="false"
						:listName="list.listName"
						:numberOfTasks="$store.state.tasks.completedTasksCount"
						class="pa-0"
						icon="$task-completed"
						v-for="list in completed"
					/>
				</template>
			</v-list-group>

			<v-list-group append-icon="">
				<template v-slot:activator>
					<task-menu-item
						:isActive="activeList === list"
						@setAciveList="setActiveList(list)"
						v-for="list in deleted"
						icon="$delete"
						class="pa-0"
						:numberOfTasks="$store.state.tasks.deletedCount"
						:listName="list.listName"
						:link="false"
						:key="list.id"
						:bold="true"
					/>
				</template>
			</v-list-group>
		</v-list>
	</div>
</template>

<script>
import TaskMenuItem from "@/components/tasks/TaskMenuItem";
import MenuTagList from "@/components/tasks/MenuTagList";

import { mapGetters, mapActions } from "vuex";

export default {
	components: {
		TaskMenuItem,
		MenuTagList,
	},

	data() {
		return {
			activeList: {},
			addListInputVisible: false,
			toDoActive: "",
			listName: "",

			toDos: [
				{
					id: 0,
					listName: this.$vuetify.lang.t(
						"$vuetify.views.tasks.taskMenu.allTasks"
					),
					numberOfTasks: 0,
					name: "",
				},
				{
					id: 1,
					listName: this.$vuetify.lang.t(
						"$vuetify.views.tasks.taskMenu.todayTasks"
					),
					numberOfTasks: 1,
					name: "today",
				},
				{
					id: 2,
					listName: this.$vuetify.lang.t(
						"$vuetify.views.tasks.taskMenu.tomorrowTasks"
					),
					numberOfTasks: 9,
					name: "tomorrow",
				},
				{
					id: 3,
					listName: this.$vuetify.lang.t(
						"$vuetify.views.tasks.taskMenu.weekTasks"
					),
					numberOfTasks: 2,
					name: "this_week",
				},
			],
			received: [
				{
					id: 0,
					listName: this.$vuetify.lang.t(
						"$vuetify.views.tasks.taskMenu.received"
					),
					name: "received",
				},
			],
			commissioned: [
				{
					id: 0,
					listName: this.$vuetify.lang.t(
						"$vuetify.views.tasks.taskMenu.commissioned"
					),
					name: "commissioned",
				},
			],
			completed: [
				{
					id: 0,
					listName: this.$vuetify.lang.t(
						"$vuetify.views.tasks.taskMenu.completed"
					),
					name: "completed",
				},
			],

			deleted: [
				{
					id: 1,
					listName: this.$vuetify.lang.t(
						"$vuetify.views.tasks.taskMenu.deleted"
					),
					name: "deleted",
				},
			],
		};
	},

	computed: {
		...mapGetters({
			tags: "tasks/tags",
			lists: "tasks/lists",
			allTasksCount: "tasks/allTasksCount",
			commisionedTasks: "tasks/commisionedTasks",
			recievedTasks: "tasks/recievedTasks",
		}),
	},

	watch: {
		activeList() {
			this.$store.state.tasks.view = this.activeList;
			this.$store.state.tasks.currentPage = 1;

			this.getTasks({ currentPage: 1 });
		},
	},

	methods: {
		...mapActions("tasks", ["postList", "getTasks"]),

		activeAddListForm() {
			this.addListInputVisible = true;
		},

		deactiveAddListForm() {
			this.addListInputVisible = false;
		},

		addNewList() {
			if (this.listName) {
				this.postList({ name: this.listName });
				this.listName = "";
				this.addListInputVisible = false;
			}
		},

		setActiveList(list) {
			this.activeList = list;
		},
	},
};
</script>

<style lang="scss" scoped>
.number-of-tasks {
	background-color: var(--v-accent-base);
	border-radius: 8px;
	color: white;

	&.number-of-tasks-secondary {
		background-color: var(--v-secondary);
		color: var(--v-accent-base);
	}

	&.empty {
		background-color: var(--v-grey-lighten2);
		color: var(--v-grey-base);
	}
}

.input {
	border-radius: 8px;
	border: solid 1px var(--v-grey-lighten3);
	box-shadow: 0 2px 2px 0 rgba(58, 57, 76, 0.08);
	transition: 0.3s;
	width: 100%;

	&:focus,
	&:hover {
		border: 1px solid var(--v-accent-base);
		outline: 0;
	}
}

.width-100 {
	width: 100%;
}
</style>
